/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import T from 'i18n-react';

import { SOLD_CATEGORY } from 'Utilities/vehicleState';

import BidCreatedAtTimer from './BidCreatedAtTimer/BidCreatedAtTimer';

T.setTexts(require('Components/texts.json'));

export const useCreatedAtBidFieldLogic = ({ className, value }) => {
	if (!value) {
		return null;
	}

	return (
		<span className={className}>
			<BidCreatedAtTimer value={value} />
		</span>
	);
};

export const getVehicleStateTagLabel = (state) => {
	const vehicleStateLabels = {
		[SOLD_CATEGORY.SOLD_CONFIRMED]: 'account.vehicleCard.sold.sold_confirmed',
		[SOLD_CATEGORY.SOLD_WAIT]: 'account.vehicleCard.sold.sold_wait',
		[SOLD_CATEGORY.SOLD_DOCUMENTS_REVIEWED]: 'account.vehicleCard.sold.checks_complete',
		[SOLD_CATEGORY.SOLD_INVOICE_PAID]: 'account.vehicleCard.sold.checks_complete',
		[SOLD_CATEGORY.SOLD]: 'account.vehicleCard.sold.checks_complete',
		[SOLD_CATEGORY.SOLD_INVOICE_RAISED]: 'account.vehicleCard.sold.checks_complete',
	};

	return vehicleStateLabels[state];
};
